<template>
   <b-modal
      hide-footer
      centered
      :title="'Historico Lote'"
      size="lg"
      ref="history-lote"
      id="history-lote">
        <div id="body-poupp-con">
          <b-tabs>
            <b-tab :title="'Reembolso'">
                <template slot="title">
                <i class="fas fa-dollar-sign text-third"></i><span class="d-md-down-none pl-1 text-third"> Rembolso Lote</span>
                </template>
                <div class="body-modal-card d-flex flex-wrap justify-content-around ">
                  <div class="card-lote mb-4" v-for="data in getAllDespesaReembolso" :key="data.id">
                    <div class="card-footer-lote">
                      {{data.lote  + ' - Lote' }}
                    </div>
                    <i class="fas fa-file-excel icone-excel"></i>
                    <div @click="download(data)" class="card-download"><i class="fas fa-download"></i></div>
                  </div>
                </div>
            </b-tab>
            <b-tab :title="'Desconto'">
                <template slot="title">
                <i class="fas fa-dollar-sign text-third"></i><span class="d-md-down-none pl-1 text-third"> Desconto Lote</span>
                </template>
                <div class="body-modal-card d-flex flex-wrap justify-content-around ">
                  <div class="card-lote mb-4" v-for="data in getAllDespesaDesconto" :key="data.id">
                    <div class="card-footer-lote">
                      {{data.lote  + ' - Lote' }}
                    </div>
                    <i class="fas fa-file-excel icone-excel"></i>
                    <div @click="download(data)" class="card-download"><i class="fas fa-download"></i></div>
                  </div>
                </div>
            </b-tab>
            <b-tab :title="'Adiantamento'">
                <template slot="title">
                <i class="fas fa-dollar-sign text-third"></i><span class="d-md-down-none pl-1 text-third"> Adiantamento Lote</span>
                </template>
                <div class="p-4">
                  <b-form-group label="Numero do lote:" label-for="input-lote-adiantamento">
                    <div class="d-flex">
                      <b-form-input
                        id="input-lote-adiantamento"
                        v-model="loteAdiantamento"
                        type="number"
                        min="1"
                        placeholder="Ex.: 661"
                        @keyup.enter="buscarLoteAdiantamento"
                        class="mr-2"
                      ></b-form-input>
                      <button class="importaexcel" @click="buscarLoteAdiantamento">
                        <i class="fas fa-download mr-1"></i> BAIXAR
                      </button>
                    </div>
                  </b-form-group>
                  <small class="text-muted">O numero do lote aparece no titulo da planilha e na coluna Lote da grid de adiantamentos.</small>
                </div>
            </b-tab>
        </b-tabs>
        </div>
    </b-modal>
</template>

<script>
import ModalHistory from './ModalHistory'
export default ModalHistory
</script>

<style scoped>
.card-lote{
  border: 1px dashed black;
  height: 200px;
  min-height: 200px;
  border-radius: 10px;
  width: 200px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-footer-lote{
  bottom: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 25px;
  background: rgb(78, 78, 78);
  color: white;
  border-radius: 0px 0px 10px 10px;
  font-weight: bold;
  position: absolute;
  align-items: center;
}
.body-modal-card{
  max-height: 75vh;
  overflow: auto;
}
.card-download{
  position: absolute;
  top: 0px;
  right: 0px;
  background: green;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  border-radius: 0px 10px 0px 10px;
  cursor: pointer;
  width: 40px;
  color: white;
}
.icone-excel{
  font-size: 50px;
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/modalhistory/ModalHistory.vue